import { IGlobalSearchRegistry } from '../interfaces/global-search';
import { GLOBAL_SEARCH_ACTIVATION_KEY, GlobalSearchActivationRegistry } from './component-registry/globalSearchActivationRegistry';
import { GLOBAL_SEARCH_DESTINATION_KEY, GlobalSearchDestinationRegistry } from './component-registry/globalSearchDestinationRegistry';
import { GLOBAL_SEARCH_DOCS_KEY, GlobalSearchDocsRegistry } from './component-registry/globalSearchDocsRegistry';
import { GLOBAL_SEARCH_MODEL_KEY, GlobalSearchModelRegistry } from './component-registry/globalSearchModelRegistry';
import { GLOBAL_SEARCH_PIPELINE_KEY, GlobalSearchPipelineRegistry } from './component-registry/globalSearchPipelineRegistry';
import {
  GLOBAL_SEARCH_PRODUCT_ROUTES_KEY,
  GlobalSearchProductRoutesRegistry
} from './component-registry/globalSearchProductRoutesRegistry';
import { GLOBAL_SEARCH_TARGET_KEY, GlobalSearchTargetRegistry } from './component-registry/globalSearchTargetRegistry';
import { GLOBAL_SEARCH_WORKFLOW_KEY, GlobalSearchWorkflowRegistry } from './component-registry/globalSearchWorkflowRegistry';

export const GLOBAL_SEARCH_REGISTRY: IGlobalSearchRegistry = {
  [GLOBAL_SEARCH_PIPELINE_KEY]: GlobalSearchPipelineRegistry,
  [GLOBAL_SEARCH_DESTINATION_KEY]: GlobalSearchDestinationRegistry,
  [GLOBAL_SEARCH_WORKFLOW_KEY]: GlobalSearchWorkflowRegistry,
  [GLOBAL_SEARCH_MODEL_KEY]: GlobalSearchModelRegistry,
  [GLOBAL_SEARCH_TARGET_KEY]: GlobalSearchTargetRegistry,
  [GLOBAL_SEARCH_ACTIVATION_KEY]: GlobalSearchActivationRegistry,
  [GLOBAL_SEARCH_PRODUCT_ROUTES_KEY]: GlobalSearchProductRoutesRegistry,
  [GLOBAL_SEARCH_DOCS_KEY]: GlobalSearchDocsRegistry,
};

